DialogController = App.loadClass 'core::Angular/DialogController'

class exports.OtherPracticesController extends DialogController
    constructor: (@scope, @transitions, @modalInstance, @http, @selections, @survey) ->
        super

        @scope.save = @save
        @scope.selections = @selections
        @scope.survey =
            id: @survey?.id
            questions: [
                {
                    text: "Do you practice Integrated Pest Management when selecting
                        and applying chemical products on your farm?"
                    answer: @survey?.question1
                },
                {
                    text: "When handling waste from your farm (containers, pallets,
                        not crop residue), do you look for opportunities to reuse and recycle
                        (e.g. composting, alternative markets, etc.)?"
                    answer: @survey?.question2
                },
                {
                    text: "Do you perform regular maintenance and, if necessary,
                        calibration of your equipment and machinery?"
                    answer: @survey?.question3
                },
                {
                    text: "If farming is your only source of income, do you have financial
                        safeguards in place to minimize risk to crop losses, such as
                        crop insurance?"
                    answer: @survey?.question4
                },
            ]
            managed_irrigated_acres: @survey?.managed_irrigated_acres ? 0
            managed_dryland_acres: @survey?.managed_dryland_acres ? 0
            autocalculate_managed_irrigated_acres: @survey?.autocalculate_managed_irrigated_acres ? true
            autocalculate_managed_dryland_acres: @survey?.autocalculate_managed_dryland_acres ? true

        # Other Practices - SRS
        # https://docs.google.com/document/d/1dm9Z81_kAaOp5mVyU5WXfAFwUrq85DsCZ2ca_GiPeV4/edit#
        #
        # I really don't think this logic is good, but it's what Chris wanted, so I'm copypasting
        # exactly what he wrote in the SRS to prove that it functions exactly as he specified.
        # Don't blame me, I'm just a code monkey.

        # ~Each time the Other Practices dialog is opened~, managed acres will be set automatically to
        # the total area across all Fieldprint Score sets for the current crop and year combination...

        # Update to the above comment. Chris says "Okay. The SRS was incorrect. Please calculate the
        # Irrigated and Dryland total area." lol I responded "If a fieldprint has Irrigated = Yes, is
        # it supposed to take only the irrigated portion of the field to add to the irrigated acres
        # and the dryland portion to add to the dryland acres? And if the fieldprint has Irrigated = No,
        # then all the acres are dryland? That sound correct?" He said "Exactly. Thanks in advance!"

        # https://www.pivotaltracker.com/story/show/152729616
        # Update to everything: Turns out I was absolutely correct in that this logic is BAD, but Chris
        # didn't complain until he actually saw it and then reneged on half the SRS. So now things are
        # changing. The total acres irrigated/dryland has to be calculated in the backend, and it has
        # to be constantly updated if anything changes. We can't have these not be columns (they are used
        # heavily in the KPI report), so we need to figure out all the places where it pulls data from in
        # the calculations. These are:
        #
        # 0. FPC result year and crop (these cannot change, so ignore)
        # 1. Irrigation map irrigated or dryland areas
        # 2. FPC result "Irrigated" toggle
        # 3. Field tillable acres
        # 4. FPC result created
        #
        # 2 can be a subset of 4. 1 and 3 are separate.
        # Each of these places needs a trigger with the following logic:
        #
        # 1. For each of totalAcresDryland and totalAcresIrrigated:
        # 2. Calculate what the acres should be
        # 3. If this value is greater than or equal to the current saved value, turn autocalculating on
        # 4. If autocalculating is on, update the current value with the calculated value
        #
        # Separately, whenever this dialog is saved, perform the following logic:
        #
        # 1. For each of totalAcresDryland and totalAcresIrrigated:
        # 2. Calculate what the acres should be
        # 3. If the new acres is less then or equal to the calculated value, set the value to the calculated value and turn autocalculating on
        # 4. If the new acres is greater than the calculated value, set the value to the new acres and turn autocalculating off

    save: (pretending) =>
        @http.post 'backend/grower/other-practices/save',
            year: @selections.year
            crop: @selections.crop
            id: @scope.survey.id
            questions: @scope.survey.questions
            managed_irrigated_acres: @scope.survey.managed_irrigated_acres
            managed_dryland_acres: @scope.survey.managed_dryland_acres
            autocalculate_managed_irrigated_acres: @scope.survey.autocalculate_managed_irrigated_acres
            autocalculate_managed_dryland_acres: @scope.survey.autocalculate_managed_dryland_acres
        .then (response) =>
            if not pretending
                @closeWithAlert
                    type: 'success'
                    msg: 'Successfully saved Other Practices'
